"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FiltersService", {
    enumerable: true,
    get: function() {
        return FiltersService;
    }
});
const _RowColorCondition = /*#__PURE__*/ _interop_require_default(require("src/models/RowColorCondition"));
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _viewwebhookmanager = require("~/utils/view-webhook-manager");
const _apphooksservice = require("~/services/app-hooks/app-hooks.service");
const _helpers = require("~/helpers");
const _catchError = require("~/helpers/catchError");
const _NocoSocket = /*#__PURE__*/ _interop_require_default(require("~/socket/NocoSocket"));
const _models = require("~/models");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _globals = require("~/utils/globals");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let FiltersService = class FiltersService {
    async hookFilterCreate(context, param) {
        (0, _helpers.validatePayload)('swagger.json#/components/schemas/FilterReq', param.filter);
        const hook = await _models.Hook.get(context, param.hookId);
        if (!hook) {
            _catchError.NcError.badRequest('Hook not found');
        }
        const filter = await _models.Filter.insert(context, _extends({}, param.filter, {
            fk_hook_id: param.hookId
        }));
        this.appHooksService.emit(_nocodbsdk.AppEvents.FILTER_CREATE, {
            filter,
            hook,
            req: param.req,
            context
        });
        return filter;
    }
    async hookFilterList(context, param) {
        return _models.Filter.rootFilterListByHook(context, {
            hookId: param.hookId
        });
    }
    async buttonFilterCreate(context, param) {
        (0, _helpers.validatePayload)('swagger.json#/components/schemas/FilterReq', param.filter);
        return await _models.Filter.insert(context, _extends({}, param.filter, {
            fk_button_col_id: param.buttonColId
        }));
    }
    async buttonFilterList(context, param) {
        return _models.Filter.rootFilterListByButtonColumn(context, {
            buttonColId: param.buttonColId
        });
    }
    async filterDelete(context, param, ncMeta) {
        if (context.schema_locked) {
            _catchError.NcError.get(context).schemaLocked();
        }
        const filter = await _models.Filter.get(context, param.filterId);
        if (!filter) {
            _catchError.NcError.badRequest('Filter not found');
        }
        const parentData = await filter.extractRelatedParentMetas(context);
        let viewWebhookManager;
        if (filter.fk_view_id) {
            const view = await _models.View.get(context, filter.fk_view_id, ncMeta);
            viewWebhookManager = (await (await new _viewwebhookmanager.ViewWebhookManagerBuilder(context, ncMeta).withModelId(view.fk_model_id)).withViewId(filter.fk_view_id)).forUpdate();
        } else if (filter.fk_row_color_condition_id) {
            const rowColorCondition = await _RowColorCondition.default.getById(context, filter.fk_row_color_condition_id, ncMeta);
            const view = await _models.View.get(context, rowColorCondition.fk_view_id, ncMeta);
            viewWebhookManager = (await (await new _viewwebhookmanager.ViewWebhookManagerBuilder(context, ncMeta).withModelId(view.fk_model_id)).withViewId(rowColorCondition.fk_view_id)).forUpdate();
        }
        await _models.Filter.delete(context, param.filterId);
        this.appHooksService.emit(_nocodbsdk.AppEvents.FILTER_DELETE, _extends({
            filter,
            req: param.req,
            context
        }, parentData));
        _NocoSocket.default.broadcastEvent(context, {
            event: _nocodbsdk.EventType.META_EVENT,
            payload: {
                action: 'filter_delete',
                payload: filter
            }
        }, context.socket_id);
        if (viewWebhookManager) {
            (await viewWebhookManager.withNewViewId(viewWebhookManager.getViewId())).emit();
        }
        return true;
    }
    async filterCreate(context, param) {
        (0, _helpers.validatePayload)('swagger.json#/components/schemas/FilterReq', param.filter);
        const view = await _models.View.get(context, param.viewId);
        const viewWebhookManager = (await (await new _viewwebhookmanager.ViewWebhookManagerBuilder(context).withModelId(view.fk_model_id)).withViewId(param.viewId)).forUpdate();
        const filter = await _models.Filter.insert(context, _extends({}, param.filter, {
            fk_view_id: param.viewId
        }));
        this.appHooksService.emit(_nocodbsdk.AppEvents.FILTER_CREATE, {
            filter,
            view,
            req: param.req,
            context
        });
        _NocoSocket.default.broadcastEvent(context, {
            event: _nocodbsdk.EventType.META_EVENT,
            payload: {
                action: 'filter_create',
                payload: filter
            }
        }, context.socket_id);
        if (viewWebhookManager) {
            (await viewWebhookManager.withNewViewId(viewWebhookManager.getViewId())).emit();
        }
        return filter;
    }
    async filterUpdate(context, param, ncMeta) {
        (0, _helpers.validatePayload)('swagger.json#/components/schemas/FilterReq', param.filter);
        const filter = await _models.Filter.get(context, param.filterId, ncMeta);
        let viewWebhookManager;
        if (filter.fk_view_id) {
            const view = await _models.View.get(context, filter.fk_view_id, ncMeta);
            viewWebhookManager = (await (await new _viewwebhookmanager.ViewWebhookManagerBuilder(context, ncMeta).withModelId(view.fk_model_id)).withViewId(filter.fk_view_id)).forUpdate();
        } else if (filter.fk_row_color_condition_id) {
            const rowColorCondition = await _RowColorCondition.default.getById(context, filter.fk_row_color_condition_id, ncMeta);
            const view = await _models.View.get(context, rowColorCondition.fk_view_id, ncMeta);
            viewWebhookManager = (await (await new _viewwebhookmanager.ViewWebhookManagerBuilder(context, ncMeta).withModelId(view.fk_model_id)).withViewId(rowColorCondition.fk_view_id)).forUpdate();
        }
        if (!filter) {
            _catchError.NcError.badRequest('Filter not found');
        }
        // todo: type correction
        const res = await _models.Filter.update(context, param.filterId, param.filter, ncMeta);
        const parentData = await filter.extractRelatedParentMetas(context, ncMeta);
        this.appHooksService.emit(_nocodbsdk.AppEvents.FILTER_UPDATE, _extends({
            filter: _extends({}, filter, param.filter),
            oldFilter: filter,
            req: param.req
        }, parentData, {
            context
        }));
        _NocoSocket.default.broadcastEvent(context, {
            event: _nocodbsdk.EventType.META_EVENT,
            payload: {
                action: 'filter_update',
                payload: filter
            }
        }, context.socket_id);
        if (viewWebhookManager) {
            (await viewWebhookManager.withNewViewId(viewWebhookManager.getViewId())).emit();
        }
        return res;
    }
    async filterChildrenList(context, param) {
        return _models.Filter.parentFilterList(context, {
            parentId: param.filterId
        });
    }
    async filterGet(context, param) {
        const filter = await _models.Filter.get(context, param.filterId);
        return filter;
    }
    async filterList(context, param) {
        const filter = await (param.includeAllFilters ? _models.Filter.allViewFilterList(context, {
            viewId: param.viewId
        }) : _models.Filter.rootFilterList(context, {
            viewId: param.viewId
        }));
        return filter;
    }
    async linkFilterCreate(_context, _param) {
        // placeholder method
        return null;
    }
    /**
   * Transform filters for a column type change - remove incompatible ones
   * Works for all filter types: hook, link, grid, etc.
   */ async transformFiltersForColumnTypeChange(context, params, ncMeta = _Noco.default.ncMeta) {
        const { columnId, newColumnType, oldColumnType, sqlUi } = params;
        // Get all filters that reference this column from all tables
        const filtersToCheck = await this.getAllFiltersForColumn(context, columnId, ncMeta);
        // Remove incompatible filters
        for (const filter of filtersToCheck){
            const validation = this.validateFilterForTypeChange(filter, newColumnType, oldColumnType, sqlUi);
            if (validation.shouldRemove) {
                await this.deleteFilter(context, filter.id, ncMeta);
            }
        }
    }
    /**
   * Get all filters that reference a specific column from all filter tables
   */ async getAllFiltersForColumn(context, columnId, ncMeta = _Noco.default.ncMeta) {
        const filters = [];
        try {
            // Query nc_filter table directly for all filters referencing this column
            const filterResults = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.FILTER_EXP, {
                xcCondition: {
                    _or: [
                        {
                            fk_column_id: {
                                eq: columnId
                            }
                        },
                        {
                            fk_value_col_id: {
                                eq: columnId
                            }
                        }
                    ]
                }
            });
            // Convert to FilterType objects
            for (const row of filterResults){
                filters.push({
                    id: row.id,
                    fk_column_id: row.fk_column_id,
                    comparison_op: row.comparison_op,
                    comparison_sub_op: row.comparison_sub_op,
                    value: row.value,
                    logical_op: row.logical_op,
                    is_group: row.is_group,
                    fk_view_id: row.fk_view_id,
                    fk_hook_id: row.fk_hook_id,
                    fk_parent_id: row.fk_parent_id,
                    children: []
                });
            }
        } catch (error) {
            console.warn(`Failed to query filters for column ${columnId}: ${error.message}`);
        }
        return filters;
    }
    /**
   * Delete a filter directly from the database
   */ async deleteFilter(context, filterId, ncMeta = _Noco.default.ncMeta) {
        await _models.Filter.delete(context, filterId, ncMeta);
    }
    /**
   * Check if an operator is compatible with a column type
   */ isOperatorCompatible(operator, columnType, oldColumnType) {
        const operators = (0, _nocodbsdk.comparisonOpList)(columnType);
        const oldOperators = (0, _nocodbsdk.comparisonOpList)(oldColumnType);
        const oldOperator = oldOperators.find((op)=>op.value === operator);
        const newOperator = operators.find((op)=>op.value === operator);
        // If operator doesn't exist in either type, it's not compatible
        if (!oldOperator || !newOperator) {
            return false;
        }
        // Check if type-specific semantic types match - this is the most reliable method
        if (oldOperator.typeSpecificSemantic && newOperator.typeSpecificSemantic) {
            const oldTypeSpecificSemantic = oldOperator.typeSpecificSemantic(oldColumnType);
            const newTypeSpecificSemantic = newOperator.typeSpecificSemantic(columnType);
            return oldTypeSpecificSemantic === newTypeSpecificSemantic;
        }
        // Fallback to basic semantic type comparison
        if (oldOperator.semanticType && newOperator.semanticType) {
            return oldOperator.semanticType === newOperator.semanticType;
        }
        // Final fallback to text comparison
        return oldOperator.text === newOperator.text;
    }
    /**
   * Validate if a filter should be removed due to column type change
   */ validateFilterForTypeChange(filter, newColumnType, oldColumnType, sqlUI) {
        const operator = filter.comparison_op;
        if (!operator) {
            return {
                shouldRemove: true,
                reason: 'Filter has no comparison operator'
            };
        }
        // check if abstract type changed
        const oldAbstractType = sqlUI.getAbstractType({
            uidt: oldColumnType
        });
        const newAbstractType = sqlUI.getAbstractType({
            uidt: newColumnType
        });
        if (oldAbstractType !== newAbstractType) {
            return {
                shouldRemove: true,
                reason: `Column abstract type changed from ${oldAbstractType} to ${newAbstractType}`
            };
        }
        // Operator is not compatible, filter must be removed
        if (!this.isOperatorCompatible(operator, newColumnType, oldColumnType)) {
            return {
                shouldRemove: true,
                reason: `Operator ${operator} is not compatible with column type ${newColumnType}`
            };
        }
        // Operator is compatible, no removal needed
        return {
            shouldRemove: false
        };
    }
    /**
   * Get all operators compatible with a column type
   */ getCompatibleOperators(columnType) {
        const operators = (0, _nocodbsdk.comparisonOpList)(columnType);
        return operators.map((op)=>op.value);
    }
    constructor(appHooksService){
        this.appHooksService = appHooksService;
        this.logger = new _common.Logger(FiltersService.name);
    }
};
FiltersService = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _apphooksservice.AppHooksService === "undefined" ? Object : _apphooksservice.AppHooksService
    ])
], FiltersService);
